import React, { Component } from 'react';
import ThemedButton from '../CommonComponents/ThemedButtons';
import AddAgent from '../assets/icons/add.svg';
import closeIcon from '../assets/icons/close.svg';
import Modal from '../CommonComponents/Modal';
import AddUserList from './AddUserList';
import { RandomizedUserBadgeColors } from '../constants';
import { api } from '../utils';
import { TreeType } from '../CommonComponents/Tree/model';
import { Tree } from '../CommonComponents/Tree';
import { Badges } from '../CommonComponents/Badges';
import InfoIcon from '../assets/icons/info.svg';
import { DuplicateQueueName } from './DuplicateQueueName';
import { SelectedAgentData } from './model';

type Props = {
  selectedBotId: string;
  closeCreateQueue?: Function;
  title?: string;
  notification: Function;
  action: string;
  prevAgentData?: any;
  selectedQueueId?: number;
  queueName: string;
  stepNotification?: number;
  tenantId: number;
  entityListLength?: number;
};

type State = {
  stepNotification: number;
  showAddAgentScreen: boolean;
  selectedAgentData: SelectedAgentData[];
  previouslyselectedAgentData: SelectedAgentData[];
  checkAlign: boolean;
  entityTree: { listEntities: TreeType[] };
  selectedNodes: { id: number; name: string }[];
  prevselectedNodes: { id: number; name: string }[];
  showSelectionOfUser: boolean;
  addNewUser: boolean;
  userFirstName: string;
  userLastName: string;
  userEmail: string;
  removeParticularNode: number;
  isDuplicateQueueNameModalOpen: boolean;
};

export default class QueueCreation extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.closeUserListModal = this.closeUserListModal.bind(this);
    this.sendFinalData = this.sendFinalData.bind(this);
    this.addNewUser = this.addNewUser.bind(this);
    this.checkEmailValidation = this.checkEmailValidation.bind(this);
    this.checkNameValidation = this.checkNameValidation.bind(this);
    this.getEntityList = this.getEntityList.bind(this);
    this.closeUserModals = this.closeUserModals.bind(this);
    this.removeSelectedNodes = this.removeSelectedNodes.bind(this);
  }
  setInitialState(): State {
    return {
      stepNotification: 1,
      showAddAgentScreen: false,
      selectedAgentData: [],
      previouslyselectedAgentData: [],
      checkAlign: false,
      entityTree: { listEntities: [] },
      selectedNodes: [],
      prevselectedNodes: [],
      showSelectionOfUser: false,
      addNewUser: false,
      userFirstName: '',
      userLastName: '',
      userEmail: '',
      removeParticularNode: -1,
      isDuplicateQueueNameModalOpen: false,
    };
  }

  componentDidMount() {
    this.getEntityList();
    if (this.props.stepNotification === 2) {
      this.setState({
        stepNotification: this.props.stepNotification,
      });
    }
  }
  getEntityList() {
    let encodedbotId = encodeURIComponent(this.props.selectedBotId);
    api(
      `getEntityList?botId=${encodedbotId}&tenantId=${
        this.props.tenantId
      }&agentSessionID=${sessionStorage.getItem('agentActiveSession')}`,
      'GET'
    ).then((data) => {
      this.setState({ entityTree: data });
      data.listEntities.map((val: any, i: number) => {
        val.queueName === this.props.title &&
          this.setState((prevState) => ({
            selectedNodes: [{ id: val.id, name: val.entityName }],
          }));
        val.children.length > 0 &&
          val.children.map((childnode: any, i: number) => {
            childnode.queueName === this.props.title &&
              this.setState((prevState) => ({
                selectedNodes: [
                  ...prevState.selectedNodes,
                  { id: childnode.id, name: childnode.entityName },
                ],
              }));
            childnode.children.length > 0 &&
              childnode.children.map((subChildNode: any, i: number) => {
                subChildNode.queueName === this.props.title &&
                  this.setState((prevState) => ({
                    selectedNodes: [
                      ...prevState.selectedNodes,
                      { id: subChildNode.id, name: subChildNode.entityName },
                    ],
                  }));
              });
          });
      });
    });
  }
  componentDidUpdate(prevProps: Props, _: State) {
    if (prevProps.selectedBotId !== this.props.selectedBotId) {
      this.getEntityList();
    }
    if (this.props.prevAgentData !== prevProps.prevAgentData) {
      if (this.props.prevAgentData) {
        this.props.prevAgentData.map((val: any, index: any) => {
          this.setState((prevState) => ({
            selectedAgentData: [
              ...prevState.selectedAgentData,
              {
                name: val.userName.toString(),
                email: val.email.toString(),
                botId: val.botId,
                check: true,
                agentId: val.agentId.toString(),
              },
            ],
            checkAlign: true,
          }));
        });
      }
    }
  }
  saveData() {
    let editedQueueName = localStorage.getItem('latestQueueNameEdited');
  }
  closeUserListModal(data: any) {
    data.map((val: any, index: number) => {
      this.setState((prevState) => ({
        showAddAgentScreen: !this.state.showAddAgentScreen,
        checkAlign: true,
        previouslyselectedAgentData: [...prevState.selectedAgentData],
        selectedAgentData: [
          ...prevState.selectedAgentData,
          {
            name: val.userName,
            email: val.email,
            check: true,
            botId: val.botId,
            agentId: val.agentId,
          },
        ],
      }));
    });
  }
  sendFinalData() {
    let finaldata = this.state.selectedAgentData.filter((data) => {
      return data.check === true;
    });
    let prevfinaldata = this.state.previouslyselectedAgentData.filter((data) => {
      return data.check === true;
    });
    let agentid: any = [];
    let entityid: any = [];
    let preventityid: any = [];
    let prevagentid: any = [];
    finaldata.map((value, i) => {
      agentid.push({ agentId: value.agentId, botId: value.botId });
    });
    prevfinaldata.map((value, i) => {
      prevagentid.push({ agentId: value.agentId, botId: value.botId });
    });
    this.state.selectedNodes.map((val, index) => {
      entityid.push(val.id);
    });
    this.state.prevselectedNodes.map((val, index) => {
      preventityid.push(val.id);
    });
    var comp_entityid = '';
    if (JSON.stringify(preventityid) === JSON.stringify(entityid)) {
      comp_entityid = 'True';
    } else {
      comp_entityid = 'False';
    }

    api(
      'createQueue',
      'POST',
      {
        botId: this.props.selectedBotId,
        entityId: entityid,
        agentId: agentid,
        // queueName: localStorage.getItem('latestQueueNameEdited'),
        queueName: this.props.title || '',
        action: this.props.action,
        queueId: +(this.props.selectedQueueId || ''),
        agentSessionID: sessionStorage.getItem('agentActiveSession'),
      },
      { needStatusCode: true }
    ).then((res) => {
      if (res) {
        if (res.statusCode === 409) {
          this.setState({ isDuplicateQueueNameModalOpen: true });
        } else {
          this.props.notification && this.props.notification(res.msg);
          this.props.closeCreateQueue && this.props.closeCreateQueue();
        }
        let latestQueueName = localStorage.getItem('latestQueueNameEdited');
        localStorage.setItem('prevQueueName', latestQueueName ? latestQueueName : '');
      }
    });
  }
  addNewUser(email: string, frstName: string, lastName: string) {
    let value = this.checkEmailValidation(email);
    let checkValidFirstname = this.checkNameValidation(frstName);
    let checkValidLastname = this.checkNameValidation(lastName);
    if (value && checkValidFirstname && checkValidLastname) {
      // let length = this.state.selectedAgentData.length;
      api('createUser', 'POST', {
        userEmail: email,
        firstName: frstName,
        lastName: lastName,
        roleName: 'Agent',
        tab: 'queue',
        // botId: encodeURIComponent(this.props.selectedBotId),
        botId: this.props.selectedBotId,
        agentId: sessionStorage.getItem('agentId'),
        // agentSessionID: sessionStorage.getItem('agentActiveSession'),
      }).then((res) => {
        if (res.msg === 'User added') {
          this.setState((prevState) => ({
            previouslyselectedAgentData: [...prevState.selectedAgentData],
            selectedAgentData: [
              ...prevState.selectedAgentData,
              {
                name: frstName + ' ' + lastName,
                email: email,
                check: true,
                botId: '',
                agentId: res.agentId.toString(),
              },
            ],
            addNewUser: !this.state.addNewUser,
            checkAlign: true,
            showAddAgentScreen: !this.state.showAddAgentScreen,
          }));
        }
        this.setState(
          {
            showAddAgentScreen: false,
            addNewUser: false,
          },
          () => {
            this.props.notification(res.msg);
          }
        );
      });
    } else if (value === false) {
      let mailValidation = document.getElementById('mail-validation-error');
      if (mailValidation) {
        mailValidation.innerHTML = 'Invalid email address, please try again';
      }
      // alert('Please enter a valid Email-id');
      return false;
    } else if (checkValidFirstname === false) {
      let fnameValidation = document.getElementById('fname-validation-error');
      if (fnameValidation) {
        fnameValidation.innerHTML = 'Please enter a valid First Name';
      }
      return false;
    } else if (checkValidLastname === false) {
      let lnameValidation = document.getElementById('lname-validation-error');
      if (lnameValidation) {
        lnameValidation.innerHTML = 'Please enter a valid Last Name';
      }
      return false;
    }
  }
  checkEmailValidation(email: string) {
    var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; //nosonar
    if (re.test(email)) {
      return true;
    } else {
      // alert('Please enter a valid email address');
      return false;
    }
  }
  checkNameValidation(name: string) {
    var regex = /^[a-zA-Z0-9 ]{2,30}$/; //nosonar
    //  var regex=/^[a-z0-9_\.]+$/;
    var spaceRegex = /\s{5,}/;
    if (name && regex.test(name.trim()) && !spaceRegex.test(name.trim())) {
      return true;
    } else {
      return false;
    }
  }
  closeUserModals(val: boolean) {
    this.setState({
      addNewUser: val,
    });
  }
  removeSelectedNodes(id: number) {
    this.setState({
      removeParticularNode: id,
    });
  }

  get AgentData() {
    return this.state.selectedAgentData.filter(
      (v, i, a) =>
        a.findIndex(
          (t) => t.name === v.name && t.email === v.email && t.botId === v.botId
        ) === i
    );
  }
  render() {
    return (
      <div className='queue-creation-wrapper'>
        <div className='queue-creation-sub-wrapper'>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className='entity-notifier'>{this.state.stepNotification}</div>
            <span style={{ marginLeft: '10px' }}>
              {this.state.stepNotification === 1 ? (
                this.props.title === 'Default' ? (
                  <div>Entities in the default queue</div>
                ) : (
                  <div>Select entities to add to this queue</div>
                )
              ) : (
                <div style={{ color: ' rgba(0,0,0,0.6)' }}>Add agents to the queue</div>
              )}
            </span>
          </div>
          {this.state.stepNotification === 1 ? (
            <div>
              {this.props.title === 'Default'
                ? this.props.entityListLength
                : this.state.selectedNodes.length}{' '}
              selected
            </div>
          ) : this.AgentData.length > 0 ? (
            <div style={{ display: 'flex', fontSize: '14px', letterSpacing: '-0.21px' }}>
              <span style={{ marginRight: '10px' }}>{this.AgentData.length}</span>
              <span>agents added</span>
            </div>
          ) : (
            ''
          )}
        </div>
        <div
          className={`main-wrapper ${
            this.state.checkAlign === false || this.AgentData.length === 0
              ? 'wrapper'
              : ''
          }`}>
          <>
            <div
              className='sub-wrappers'
              style={{ display: this.state.stepNotification === 1 ? 'block' : 'none' }}>
              <Tree
                data={this.state.entityTree.listEntities}
                level={0}
                parentId={0}
                notifyParent={(data) =>
                  this.setState((prevState) => ({
                    prevselectedNodes: [...prevState.selectedNodes],
                    selectedNodes: data,
                  }))
                }
                title={this.props.title ? this.props.title : ''}
                removeParticularNode={this.state.removeParticularNode}
              />
            </div>
            <div
              className='sub-wrappers'
              style={{
                marginLeft: '30px',
                padding: '20px',
                display: this.state.stepNotification === 1 ? 'block' : 'none',
              }}>
              {this.state.selectedNodes && (
                <Badges
                  items={this.state.selectedNodes.map((sn) => ({
                    name: sn.name,
                    title: sn.name,
                    id: sn.id,
                  }))}
                  isMutable={false}
                  removeSelectedNodes={this.removeSelectedNodes}
                  title={this.props.title ? this.props.title : ''}
                />
              )}
            </div>
          </>
          {this.state.stepNotification === 2 && this.AgentData.length > 0 ? (
            <div style={{ justifyContent: 'flex-start' }}>
              <div
                className='add-agent-btn'
                onClick={() => {
                  this.setState({ showAddAgentScreen: true });
                }}>
                <img src={AddAgent} alt='add agent' />
                Add agent
              </div>
              {this.AgentData.map((data: any, index) => {
                if (data.check) {
                  return (
                    <div
                      style={{
                        display: 'flex',
                        padding: '20px 0px 20px 0px',
                        justifyContent: 'space-between',
                        width: '470px',
                        overflowY: 'auto',
                      }}>
                      <div style={{ display: 'flex' }}>
                        <div
                          style={{
                            backgroundColor:
                              RandomizedUserBadgeColors[
                                data.name[0].toLocaleLowerCase().charCodeAt(0) % 97
                              ],
                            marginLeft: '0px',
                          }}
                          className='user-badge'>
                          {data.name[0]}
                        </div>
                        <div className='user-details'>
                          <span
                            style={{
                              textTransform: 'capitalize',
                              letterSpacing: ' -0.21px',
                              fontSize: '14px',
                            }}>
                            {data.name}
                          </span>
                          <span
                            style={{
                              fontSize: '12px',
                              color: 'rgba(0,0,0,0.6)',
                              letterSpacing: '-0.18px',
                            }}>
                            {data.email}
                          </span>
                        </div>
                      </div>
                      <div
                        onClick={() => {
                          this.setState((prevState) => ({
                            previouslyselectedAgentData: [...prevState.selectedAgentData],
                            selectedAgentData: prevState.selectedAgentData.filter(
                              (obj) => obj.name !== data.name
                            ),
                          }));
                        }}
                        style={{ cursor: 'pointer' }}>
                        <img
                          src={closeIcon}
                          alt='close'
                          style={{ width: '20px', height: '20px' }}
                        />
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          ) : this.state.stepNotification === 2 && this.AgentData.length === 0 ? (
            <div className='adding-agent-wrapper '>
              <div className='add-agent-tite'>No agents added yet</div>
              <div
                className='add-agent-btn'
                onClick={() => {
                  this.setState({ showAddAgentScreen: true });
                }}>
                <img src={AddAgent} alt='add agent' />
                Add agent
              </div>
            </div>
          ) : null}
        </div>
        <div
          style={
            this.props.title === 'Default' && this.state.stepNotification === 1
              ? {
                  display: 'flex',
                  alignItems: 'baseline',
                  justifyContent: 'space-between',
                }
              : {}
          }>
          {this.props.title === 'Default' && this.state.stepNotification === 1 && (
            <div style={{ display: 'flex' }}>
              <img src={InfoIcon} alt='info' style={{ width: '24px', height: '24px' }} />
              <div
                style={{
                  fontSize: '12px',
                  lineHeight: '1.5',
                  letterSpacing: '-0.18px',
                  color: 'rgba(0,0,0,0.6)',
                  marginLeft: '7px',
                  width: '426px',
                }}>
                Entities can’t be directly edited in the default queue. However any entity
                which is removed from other queues automatically moves to the default
                queue
              </div>
            </div>
          )}
          <div className='btns-wrapper'>
            <div style={{ marginRight: '12px' }}>
              <ThemedButton
                title={this.state.stepNotification === 1 ? 'Done' : 'Back'}
                theme='3'
                onClick={() => {
                  if (this.state.stepNotification === 1) {
                    this.saveData();
                    this.sendFinalData();
                  } else {
                    this.setState({
                      stepNotification: 1,
                    });
                  }
                }}
                // disabled={
                //   this.state.stepNotification === 1
                //     ? this.state.selectedNodes.length > 0 &&
                //       this.props.queueName.length > 0
                //     : true
                // }
              />
            </div>
            <ThemedButton
              title={this.state.stepNotification === 1 ? 'Next' : 'Done'}
              theme='4'
              onClick={() => {
                if (this.state.stepNotification === 1) {
                  this.setState({
                    stepNotification: this.state.stepNotification + 1,
                  });
                } else {
                  this.sendFinalData();
                }
              }}
              // disabled={
              //   this.state.selectedNodes.length > 0 && this.props.queueName.length > 0
              // }
            />
          </div>
        </div>
        <Modal
          isOpen={this.state.showAddAgentScreen}
          title='Select users'
          onClose={() => {
            this.setState({
              showAddAgentScreen: !this.state.showAddAgentScreen,
              showSelectionOfUser: !this.state.showSelectionOfUser,
            });
          }}>
          <AddUserList
            onSelection={this.closeUserListModal}
            botId={this.props.selectedBotId}
            notification={this.props.notification}
            addNewUser={this.addNewUser}
            closeAddNewUser={this.state.addNewUser}
            closeModals={this.closeUserModals}
            action={this.props.action}
            SelectedAgentData={this.AgentData}
            tenantId={this.props.tenantId}
            queueName={this.props.title || ''}
          />
        </Modal>
        <Modal
          isOpen={this.state.isDuplicateQueueNameModalOpen}
          onClose={() => this.setState({ isDuplicateQueueNameModalOpen: false })}
          source='general-tab'
          title='Name already in use'>
          <DuplicateQueueName
            onDone={() => this.setState({ isDuplicateQueueNameModalOpen: false })}
            // queueName={localStorage.getItem('latestQueueNameEdited') || ''}
            queueName={this.props.title || ''}
          />
        </Modal>
      </div>
    );
  }
}
